var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "table-wrapper loading-wrapper",
      class: { "is-loading": _vm.isLoading },
    },
    [
      _vm.showShowAll
        ? _c("div", { staticClass: "table-switch" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("filter_show_all")) + "\n      "
              ),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showAll,
                      expression: "showAll",
                    },
                  ],
                  attrs: { type: "checkbox", value: "1" },
                  domProps: {
                    checked: Array.isArray(_vm.showAll)
                      ? _vm._i(_vm.showAll, "1") > -1
                      : _vm.showAll,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.showAll,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "1",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.showAll = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showAll = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showAll = $$c
                        }
                      },
                      _vm.onChangeShowAll,
                    ],
                  },
                }),
                _vm._v(" "),
                _c("span"),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showShowDeactivatedOnly
        ? _c("div", { staticClass: "table-switch" }, [
            _c("span", { staticClass: "label" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("filter_show_all")) + "\n      "
              ),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.showDeactivatedOnly,
                      expression: "showDeactivatedOnly",
                    },
                  ],
                  attrs: { type: "checkbox", value: "1" },
                  domProps: {
                    checked: Array.isArray(_vm.showDeactivatedOnly)
                      ? _vm._i(_vm.showDeactivatedOnly, "1") > -1
                      : _vm.showDeactivatedOnly,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.showDeactivatedOnly,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "1",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.showDeactivatedOnly = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showDeactivatedOnly = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showDeactivatedOnly = $$c
                        }
                      },
                      _vm.onChangeShowDeactivatedOnly,
                    ],
                  },
                }),
                _vm._v(" "),
                _c("span"),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", [
        _vm.getHeaderRow
          ? _c("thead", [
              _c(
                "tr",
                [
                  _vm._l(_vm.columns, function (column) {
                    return [
                      _c(
                        "th",
                        {
                          class: column.class,
                          style: column.width
                            ? "width: " +
                              column.width +
                              "; min-width: " +
                              column.width
                            : "",
                        },
                        [_vm._v(_vm._s(column.label))]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm.rows.length === 0
              ? [
                  _c("tr", { staticClass: "table-row-empty" }, [
                    _c("td", { attrs: { colspan: _vm.getVisibleColumns } }, [
                      _vm._v(_vm._s(_vm.emptyMessage)),
                    ]),
                  ]),
                ]
              : _vm._l(_vm.rows, function (row, index) {
                  return [
                    _c(
                      "tr",
                      {
                        class: {
                          "table-row-active": _vm.isVisibleDetailRow(
                            row[_vm.detailRowId]
                          ),
                          odd: index % 2 === 0,
                          even: index % 2 !== 0,
                          [_vm.rowClass(row, index)]: true,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onClickRow(row, $event)
                          },
                        },
                      },
                      [
                        _vm._l(_vm.columns, function (column) {
                          return [
                            _c(
                              "td",
                              {
                                class: column.class,
                                style: column.width
                                  ? "width: " +
                                    column.width +
                                    "; min-width: " +
                                    column.width
                                  : "",
                              },
                              [
                                _vm._t(
                                  column.key,
                                  function () {
                                    return [_vm._v(_vm._s(row[column.key]))]
                                  },
                                  { row: row }
                                ),
                              ],
                              2
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.getDetailRow
                      ? [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isVisibleDetailRow(
                                    row[_vm.detailRowId]
                                  ),
                                  expression:
                                    "isVisibleDetailRow(row[detailRowId])",
                                },
                              ],
                              staticClass: "table-row-detail",
                              class: {
                                odd: index % 2 === 0,
                                even: index % 2 !== 0,
                              },
                            },
                            [
                              _c(
                                "td",
                                { attrs: { colspan: _vm.getVisibleColumns } },
                                [_vm._t("detail-row", null, { row: row })],
                                2
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ]
                }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "loading-message" }, [
            _vm._v(_vm._s(_vm.$t("results_loading"))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }